export default __webpack_public_path__ + "static/media/TrustWallet.123a2360.svg";